﻿﻿export interface IManualTargetedChainEnd {
    recipientCenter: string;
    recipientId: number;
    recipientAlias: string;
    recipientBloodType: string;
    oTiterString: string;
    maxDonorAge: number;
    minHLAMatch: number;
    cPRA4: number;
    recipientStatusId: number;
    recipientStatus: string;
    chainId: number;
    compatiblePairStartDate: string;
    compatiblePairEndDate: string;
    clCu: number;
    rAge: number;
    rmPa: number;
    rmPb: number;
    rmPc: number;
    dialysis: string;
    wait: number;
    rexmStatus: string;
    exportableDaysInNkr: number;
    acceptedDonors: number;
    sortOrder: number;
    declineRatio: number;
}
